import React from "react";
import { useParams } from "react-router-dom";
import "./BlogDetails.css";
import blogDetailsen from "../../../Data/BlogDetailsEn";
import blogDetailsfr from "../../../Data/French/BlogDetailsFr";

export default function BlogDetails({ currentLanguage = "en" }) {
  const { id } = useParams();
  const isFrench = currentLanguage === "fr";
  const dataSource = isFrench ? blogDetailsfr : blogDetailsen;
  const data = dataSource.find((item) => item.id === parseInt(id));

  if (!data) return <div>Blog Not Found</div>;

  return (
    <div className="blog-detail-wrapper">

      {/* Title */}
      <h1 className="blogdetail-title">{data.title}</h1>

      {/* Hero Image */}
      <div className="blogdetail-img-container">
        <img src={data.heroImg} alt="Blog detail banner" className="blogdetail-img" />
      </div>

      {/* Intro */}
      <p className="blogdetail-text">
        {data.intro}
        <br /><br />
        {data.intro2}
      </p>

      {/* What Is IFU Section */}
      <div className="foundation-section">
        <div className="foundation-line"></div>
        <div>
          <h3 className="blogdetail-subheading">{data.sectionTitle}</h3>
          <p className="blogdetail-text">{data.sectionText1}</p>
          <p className="blogdetail-text">{data.sectionText2}</p>
        </div>
      </div>

      {/* IFU Meaning */}
      {data.meaningTitle && (
        <div className="foundation-section">
          <div className="foundation-line"></div>
          <div>
            <h3 className="blogdetail-subheading">{data.meaningTitle}</h3>
            <p className="blogdetail-text">{data.meaningText}</p>
          </div>
        </div>
      )}

      {/* Is IFU a Tax Number */}
      {data.taxTitle && (
        <div className="foundation-section">
          <div className="foundation-line"></div>
          <div>
            <h3 className="blogdetail-subheading">{data.taxTitle}</h3>
            <p className="blogdetail-text">{data.taxText}</p>
          </div>
        </div>
      )}

      {/* Key IFU Benefits */}
      {data.benefitsTitle && (
        <div className="implementation-box">
          <h3 className="implementation-title">{data.benefitsTitle}</h3>
          <p className="implementation-desc">{data.benefitsIntro}</p>
          <ul className="phases-list">
            {data.benefits.map((benefit) => (
              <li key={benefit.no}>
                <span className="phase-number">{benefit.no}</span>
                <div>
                  <h6 className="phase-title">{benefit.title}</h6>
                  <p className="phase-desc">{benefit.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* IFU for Business */}
      {data.businessTitle && (
        <div className="foundation-section">
          <div className="foundation-line"></div>
          <div>
            <h3 className="blogdetail-subheading">{data.businessTitle}</h3>
            <p className="blogdetail-text">{data.businessText}</p>
          </div>
        </div>
      )}

      {/* Registration Process */}
      <div className="implementation-box">
        <h3 className="implementation-title">{data.implementationTitle}</h3>
        <p className="implementation-desc">{data.implementationDesc}</p>
        <h5 className="key-phases-title">{data.keyPhases}</h5>
        <ul className="phases-list">
          {data.phases.map((phase) => (
            <li key={phase.no}>
              <span className="phase-number">{phase.no}</span>
              <div>
                <h6 className="phase-title">{phase.title}</h6>
                <p className="phase-desc">{phase.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Things to Keep in Mind */}
      {data.tipsTitle && (
        <div className="foundation-section">
          <div className="foundation-line"></div>
          <div>
            <h3 className="blogdetail-subheading">{data.tipsTitle}</h3>
            <ul className="tips-list">
              {data.tips.map((tip, index) => (
                <li key={index} className="tip-item">
                  {tip}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* Conclusion */}
      {data.conclusionTitle && (
        <div className="foundation-section">
          <div className="foundation-line"></div>
          <div>
            <h3 className="blogdetail-subheading">{data.conclusionTitle}</h3>
            <p className="blogdetail-text">{data.conclusionText}</p>
          </div>
        </div>
      )}

    </div>
  );
}